const Sdata = [
    {
        id: "1",
        imgsrc: "https://picsum.photos/id/237/200/300",
        title: "Card title 1",
        text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
        link: "alpha.html",
    },
    {
        id: "2",
        imgsrc: "https://picsum.photos/id/238/200/300",
        title: "Card title 2",
        text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
        link: "alpha.html",
    },
    {
        id: "3",
        imgsrc: "https://picsum.photos/id/239/200/300",
        title: "Card title 3",
        text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
        link: "alpha.html",
    },
    {
        id: "4",
        imgsrc: "https://picsum.photos/id/240/200/300",
        title: "Card title 4",
        text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
        link: "alpha.html",
    },
    {
        id: "5",
        imgsrc: "https://picsum.photos/id/241/200/300",
        title: "Card title 5",
        text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
        link: "alpha.html",
    },
];

export default Sdata;